import createReduxModule from '@clearscore/redux.create-requests';

import * as customTypes from './internal-identity.types';
import * as actionCreators from './internal-identity.actions';
import * as requestActionCreators from './internal-identity.request-actions';
import * as customSelectors from './selectors';
import { domain } from './reducers';

export const moduleName = 'identity';
const redux = createReduxModule({ moduleName, actionCreators: requestActionCreators });

export const types = {
    ...redux.types,
    ...customTypes,
};

export const actions = {
    ...redux.actions,
    ...actionCreators,
};
export const reducers = {
    domain: domain(redux),
};
export const selectors = {
    ...redux.selectors,
    ...customSelectors,
};
